<template>
  <div>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-toolbar color="white" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-car</v-icon>
            {{ $i18n.t("Select Cargo") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="2" sm="4">
              <v-text-field
                :label="$i18n.t('Cargo No')"
                class="purple-input"
                v-model="filters.no"
              />
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <z-client-select class="purple-input" v-model="filters.corp_id" />
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <z-country-select
                class="purple-input"
                v-model="filters.country"
              />
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <z-city-select
                class="purple-input"
                :country="filters.country"
                v-model="filters.city"
              />
            </v-col>

            <v-spacer />
            <v-col cols="12" md="2" sm="4" class="text-right pull-right my-3">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="black"
                    text
                    fab
                    x-small
                    @click="clearSearch()"
                    style="margin-right:2px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                x-small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-btn
            v-if="grid != undefined && !grid.records"
            class="text-center secondary--text pa-10"
            text
            color="primary"
            style="width:100%"
            :loading="loading"
            >{{ $i18n.t("No records available") }}</v-btn
          >
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-simple-table dense v-if="grid.records">
                <thead>
                  <tr>
                    <th class="primary--text">{{ $i18n.t("Cargo No") }}</th>
                    <th class="primary--text">{{ $i18n.t("Client Name") }}</th>
                    <th class="primary--text">{{ $i18n.t("Source") }}</th>
                    <th class="primary--text">{{ $i18n.t("Destination") }}</th>
                    <th class="primary--text">{{ $i18n.t("Truck Type") }}</th>
                    <th class="primary--text">{{ $i18n.t("Material") }}</th>
                    <th class="primary--text text-right">
                      {{ $i18n.t("Weight") }}
                    </th>
                    <th class="text-right primary--text">
                      {{ $i18n.t("Action") }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="cargo in grid.rows" :key="cargo._id">
                    <td>{{ cargo.no }}</td>
                    <td>{{ cargo.clientName }}</td>
                    <td>
                      {{ cargo.src.city + ", " + cargo.src.addressLine }}
                    </td>
                    <td>
                      {{ cargo.dst.city + ", " + cargo.dst.addressLine }}
                    </td>
                    <td>{{ cargo.vehicleType }}</td>
                    <td>{{ cargo.material }}</td>
                    <td class="text-right">{{ cargo.weight }}</td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="float-right"
                            color="primary"
                            small
                            fab
                            text
                            dark
                            v-on="on"
                            @click="select(cargo)"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-pagination
                v-if="grid.records"
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";
import orderBy from "lodash/upperFirst";

@Component({
  name: "CargoSelect",
  props: {
    corp_id: {
      default: null,
    },
    value: {
      default: null,
    },
    idOnly: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: "Cargo",
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
    btn: {
      default: false,
    },
    prependIcon: {
      default: undefined,
    },
    prependInnerIcon: {
      default: undefined,
    },
    rules: {
      default: () => [],
    },
    dialog: {
      default: false,
    },
  },
})
export default class CargoSelect extends (Vue, Themeable) {
  grid = {};
  rows = 20;
  url = "/api/cargo/grid?rows=";
  on = null;
  page = 1;
  cargo = null;
  cargos = [];
  filters = {
    no: "",
    corp_id: "",
    country: "",
    city: "",
  };
  loading = false;

  async mounted() {
    await this.onValueChange(this.value);
  }

  async showPage(page) {
    this.loading = true;
    this.page = page;
    this.grid = await doGet(
      this.url + this.rows + this.filterUrl + "&page=" + page
    );
    this.loading = false;
  }

  async clearSearch() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  close() {
    this.$emit("input", null);
  }

  select(cargo) {
    this.cargo = cargo;
    this.cargos = [cargo];
    if (this.idOnly === false) {
      this.$emit("input", cargo);
    } else {
      this.$emit("input", cargo._id);
    }
  }

  async search() {
    let filterUrl = "";
    if (this.filters.no) filterUrl += "&no=" + this.filters.no;
    if (this.filters.corp_id) filterUrl += "&corp_id=" + this.filters.corp_id;
    if (this.filters.country)
      filterUrl += "&src.country=" + this.filters.country;
    if (this.filters.city) filterUrl += "&src.city=" + this.filters.city;
    this.filterUrl = filterUrl;
    common.setLoading(true);
    await this.showPage(1);
  }

  tableHeight() {
    return window.innerHeight - 400 + "px";
  }

  changedTo(newVal) {
    if (newVal) {
      if (this.multiple === false) {
        this.cargo = newVal;
        if (this.idOnly === false) {
          this.$emit("input", newVal);
        } else {
          this.$emit("input", newVal._id);
        }
      } else {
        const response = [];
        for (let i = 0; i < newVal.length; i++) {
          response.push(newVal[i]._id);
        }
        this.$emit("input", response);
      }
    } else {
      this.$emit("input", null);
      this.cargos = [];
    }
  }

  @Watch("dialog")
  async onDialogChange(val) {
    if (val) {
      if (!this.corp_id) {
        common.setError("Please provide client");
        this.$emit("input", null);
      }
      try {
        this.grid = await doGet(this.url + this.rows);
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  @Watch("value")
  async onValueChange() {
    this.loading = true;
    this.cargo = null;
    if (this.idOnly === false) {
      if (this.value && this.value.regNo) {
        this.cargo = await doGet(
          "/api/vehicle/" +
            (this.value._id ? this.value._id : "null") +
            "/limitedDetail?regNo=" +
            this.value.regNo
        );
        this.cargos = [this.cargo];
      }
    } else if (this.value) {
      this.cargo = await doGet("/api/vehicle/" + this.value + "/limitedDetail");
      this.cargos = [this.cargo];
    }
    this.loading = false;
  }

  selected(val) {
    if (val != null && val._id != null && this.value != null) {
      if (Array.isArray(this.value)) {
        return this.value.includes(val._id);
      } else if (this.value === val._id) {
        return true;
      }
    }
    return false;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
